<template>
  <div>
    <div class="w3-row">
      <div class="w3-col s12" :class="hideSidebar ? 'm12' : 'm8'">
        <!-- Welcome Page -->
        <div v-if="page === 'welcome'">
          <template v-if="pendingAds.length">
            <div class="sectionHeader">
              <h5>Pending Ads</h5>
            </div>
            <div class="flowGrid pendingAds w3-dark-blue-grey" style="padding:8px; margin: 0 4px 8px;" v-if="width > 600">
              <div>User</div>
              <div>Title</div>
              <div class="w3-center">Placement</div>
              <div class="w3-center">Start</div>
              <div class="w3-center">Status</div>
              <div class="w3-center">Actions</div>
            </div>
            <div class="flowGrid pendingAds whiteContainer pointer" v-for="(ad, index) of pendingAds" :key="index">
              <div class="rowHeight"><span v-if="width < 600">Email: </span>{{ad.email | truncate(20)}}</div>
              <div class="rowHeight"><span v-if="width < 600">Title: </span>{{ad.title | truncate(20)}}</div>
              <div class="w3-center rowHeight"><span v-if="width < 600">Placement: </span>{{ad.placement | capitalize}}</div>
              <div class="w3-center rowHeight"><span v-if="width < 600">Start: </span>{{ad.start | date('shortDate')}}</div>
              <div class="w3-center rowHeight"><span v-if="width < 600">Status: </span>{{ad.status || 'Unknown'}}</div>
              <div class="w3-center">
                <button class="w3-button w3-green w3-small" @click="decideAd(ad, true)"><font-awesome-icon icon="check-circle"></font-awesome-icon></button>
                <button class="w3-button w3-red w3-small" @click="decideAd(ad, false)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
          </template>

          <template v-if="pendingEvents.length">
            <div class="sectionHeader">
              <h5>Pending Events</h5>
            </div>
            <div class="flowGrid pendingEvents w3-dark-blue-grey" style="padding:8px; margin: 0 4px 8px;" v-if="width > 600">
              <div>User</div>
              <div>Title</div>
              <div class="w3-center">First Date</div>
              <div class="w3-center">Actions</div>
            </div>
            <div class="flowGrid pendingEvents whiteContainer pointer" v-for="(event, index) of pendingEvents" :key="index">
              <div class="rowHeight" @click="viewEvent(event)"><span v-if="width < 600">Email: </span>{{event.email}}</div>
              <div class="rowHeight" @click="viewEvent(event)"><span v-if="width < 600">Title: </span>{{event.title | truncate(20)}}</div>
              <div class="w3-center rowHeight" @click="viewEvent(event)"><span v-if="width < 600">First Date: </span>{{event.dates[0].date}}</div>
              <div class="w3-center">
                <button class="w3-button w3-green w3-small" @click="decideEvent(event, true)"><font-awesome-icon icon="check-circle"></font-awesome-icon></button>
                <button class="w3-button w3-red w3-small" @click="decideEvent(event, false)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
          </template>

          <div class="sectionHeader">
            <h5>Attractions</h5>
          </div>
          <attractions layout="admin" :admin="true" @pageNav="pageNav" @editPlace="editPlace" @removePlace="removePlace"></attractions>
          
          <div class="sectionHeader">
            <h5>Parks</h5>
          </div>
          <parks layout="admin" :admin="true" @pageNav="pageNav" @editPlace="editPlace" @removePlace="removePlace"></parks>

          <div class="sectionHeader">
            <h5>Dining</h5>
          </div>
          <dining layout="admin" :admin="true" @pageNav="pageNav" @editPlace="editPlace" @removePlace="removePlace"></dining>

          <!-- <div class="sectionHeader">
            <h5>Chamber Events</h5>
          </div> -->
          <!-- <rss></rss> -->
          <!-- <dining layout="admin" :admin="true" @pageNav="pageNav" @editPlace="editPlace" @removePlace="removePlace"></dining> -->
        </div>

        <!-- Attraction Edit Page -->
        <div v-if="page === 'attraction-edit'">
          <div class="whiteContainer">
            <div class="w3-row">
              <div class="w3-col s12 l6" style="padding-right:8px;">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Attraction Name" aria-label="Attraction Name" v-model="selectedAttraction.name">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Attraction Phone" aria-label="Attraction Phone" v-model="selectedAttraction.phone">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Attraction Website" aria-label="Attraction Website" v-model="selectedAttraction.website">
                <textarea class="w3-input w3-border w3-margin-bottom" id="about" rows="3" v-model="selectedAttraction.description" placeholder="Attraction description"></textarea>

                <div class="placeAddress" v-if="selectedAttraction.formatted_address">
                  {{selectedAttraction.formatted_address.street_number}} {{selectedAttraction.formatted_address.street_name}}<br />
                  {{selectedAttraction.formatted_address.city}}, {{selectedAttraction.formatted_address.state}}&nbsp;&nbsp;{{selectedAttraction.formatted_address.postal_code}}
                </div>
              </div>
              <div class="w3-col s12 l6">
                <div class="w3-margin-bottom w3-center">
                  <div class="sectionHeader">
                    <h5>Attraction Image</h5>
                  </div>
                  <div class="progress" style="padding:0 4px;">
                    <div class="progress-bar" role="progressbar" :style="{width: uploadProgress + '%'}"></div>
                  </div>
                  <div class="placeAddress" style="margin:0 4px;">
                    <img v-if="selectedAttraction.imageUrl" :alt="selectedAttraction.name" :src="selectedAttraction.imageUrl" style="width:100%; max-width:300px;">
                    <p v-if="!selectedAttraction.images">Please add an event image using the "Choose File" button below.</p>
                    <input type="file" @change="uploadImage($event, 'attraction')" accept=".png,.jpg" />
                  </div>
                </div>
                <div class="errorMessageContainer w3-margin-bottom" v-if="errorMessage">
                  <h5 class="text-danger">{{errorMessage}}</h5>
                </div>
                <div class="successMessageContainer w3-margin-bottom" v-if="successMessage">
                  <h5 class="text-success">{{successMessage}}</h5>
                </div>
              </div>
            </div>
            <div class="w3-row">
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-red" @click="cancelUpdate()">Cancel</button>
              </div>
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-green" @click="updateAttraction(selectedAttraction.uid, selectedAttraction)">Update Attraction</button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Park Edit Page -->
        <div v-if="page === 'park-edit'">
          <div class="whiteContainer">
            <div class="w3-row">
              <div class="w3-col s12 l6" style="padding-right:8px;">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Park Name" aria-label="Park Name" v-model="selectedPark.name">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Park Phone" aria-label="Park Phone" v-model="selectedPark.phone">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Park Website" aria-label="Park Website" v-model="selectedPark.website">
                <textarea class="w3-input w3-border w3-margin-bottom" id="about" rows="3" v-model="selectedPark.description" placeholder="Park description"></textarea>

                <div class="placeAddress" v-if="selectedPark.formatted_address">
                  {{selectedPark.formatted_address.street_number}} {{selectedPark.formatted_address.street_name}}<br />
                  {{selectedPark.formatted_address.city}}, {{selectedPark.formatted_address.state}}&nbsp;&nbsp;{{selectedPark.formatted_address.postal_code}}
                </div>
              </div>
              <div class="w3-col s12 l6">
                <div class="w3-margin-bottom w3-center">
                  <div class="sectionHeader">
                    <h5>Park Image</h5>
                  </div>
                  <div class="progress" style="padding:0 4px;">
                    <div class="progress-bar" role="progressbar" :style="{width: uploadProgress + '%'}"></div>
                  </div>
                  <div class="placeAddress" style="margin:0 4px;">
                    <img v-if="selectedPark.imageUrl" :alt="selectedPark.name" :src="selectedPark.imageUrl" style="width:100%; max-width:300px;">
                    <p v-if="!selectedPark.images">Please add an event image using the "Choose File" button below.</p>
                    <input type="file" @change="uploadImage($event, 'park')" accept=".png,.jpg" />
                  </div>
                </div>
                <div class="errorMessageContainer w3-margin-bottom" v-if="errorMessage">
                  <h5 class="text-danger">{{errorMessage}}</h5>
                </div>
                <div class="successMessageContainer w3-margin-bottom" v-if="successMessage">
                  <h5 class="text-success">{{successMessage}}</h5>
                </div>
              </div>
            </div>
            <div class="w3-row">
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-red" @click="cancelUpdate()">Cancel</button>
              </div>
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-green" @click="updatePlace(selectedPark.uid, selectedPark)">Update Park</button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Restaurant Edit Page -->
        <div v-if="page === 'restaurant-edit'">
          <div class="whiteContainer">
            <div class="w3-row">
              <div class="w3-col s12 l6" style="padding-right:8px;">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Restaurant Name" aria-label="Restaurant Name" v-model="selectedRestaurant.name">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Restaurant Phone" aria-label="Restaurant Phone" v-model="selectedRestaurant.phone">
                <input type="text" class="w3-input w3-border w3-margin-bottom" placeholder="Restaurant Website" aria-label="Restaurant Website" v-model="selectedRestaurant.website">
                <textarea class="w3-input w3-border w3-margin-bottom" id="about" rows="3" v-model="selectedRestaurant.description" placeholder="Restaurant description"></textarea>

                <div class="placeAddress" v-if="selectedRestaurant.formatted_address">
                  {{selectedRestaurant.formatted_address.street_number}} {{selectedRestaurant.formatted_address.street_name}}<br />
                  {{selectedRestaurant.formatted_address.city}}, {{selectedRestaurant.formatted_address.state}}&nbsp;&nbsp;{{selectedRestaurant.formatted_address.postal_code}}
                </div>
              </div>
              <div class="w3-col s12 l6">
                <div class="w3-margin-bottom w3-center">
                  <div class="sectionHeader">
                    <h5>Restaurant Image</h5>
                  </div>
                  <div class="progress" style="padding:0 4px;">
                    <div class="progress-bar" role="progressbar" :style="{width: uploadProgress + '%'}"></div>
                  </div>
                  <div class="placeAddress" style="margin:0 4px;">
                    <img v-if="selectedRestaurant.imageUrl" :alt="selectedRestaurant.name" :src="selectedRestaurant.imageUrl" style="width:100%; max-width:300px;">
                    <p v-if="!selectedRestaurant.images">Please add an event image using the "Choose File" button below.</p>
                    <input type="file" @change="uploadImage($event, 'restaurant')" accept=".png,.jpg" />
                  </div>
                </div>
                <div class="errorMessageContainer w3-margin-bottom" v-if="errorMessage">
                  <h5 class="text-danger">{{errorMessage}}</h5>
                </div>
                <div class="successMessageContainer w3-margin-bottom" v-if="successMessage">
                  <h5 class="text-success">{{successMessage}}</h5>
                </div>
              </div>
            </div>
            <div class="w3-row">
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-red" @click="cancelUpdate()">Cancel</button>
              </div>
              <div class="w3-col s12 m6">
                <button class="w3-button w3-block w3-green" @click="updatePlace(selectedRestaurant.uid, selectedRestaurant)">Update Restaurant</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sidebar / Top-->
      <div class="w3-col s12 m4" v-if="!hideSidebar">
        <div class="sectionHeader">
          <h5>Admin Actions</h5>
        </div>
        <div style="margin:0 4px;">
          <input v-on:keyup="gplaces" type="text" class="w3-input w3-border w3-block addInput" placeholder="Search Attractions" aria-label="Attraction Name">
          <button @click="addPlace('attraction')" class="w3-button w3-block" :class="attractionAdded ? 'w3-red' : 'w3-green'">
            <span v-if="!placeAdded && !attractionAdded">Add Attraction</span>
            <span v-if="attractionAdded">Attraction Added</span>
          </button>

          <input v-on:keyup="gplaces" type="text" class="w3-input w3-border w3-block addInput" placeholder="Search Restaurants" aria-label="Restaurant Name">
          <button @click="addPlace('restaurant')" class="w3-button w3-block" :class="restaurantAdded ? 'w3-red' : 'w3-green'">
            <span v-if="!placeAdded && !restaurantAdded">Add Restaurant</span>
            <span v-if="restaurantAdded">Restaurant Added</span>
          </button>
          
          <input v-on:keyup="gplaces" type="text" class="w3-input w3-border w3-block addInput" placeholder="Search Parks" aria-label="Park Name">
          <button @click="addPlace('park')" class="w3-button w3-block" :class="parkAdded ? 'w3-red' : 'w3-green'">
            <span v-if="!placeAdded && !parkAdded">Add Park</span>
            <span v-if="parkAdded">Park Added</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { storage } from '../main'
import gmapsInit from '../gmaps'
import * as moment from 'moment'
import attractions from '@/components/attractions.vue'
import parks from '@/components/parks.vue'
import dining from '@/components/dining.vue'
// import rss from '@/components/rss.vue'


export default {
  name: "Admin",
  computed: {
    pendingAds() {
      let obtainedAds = this.allAds.filter((ad) => {
        if (ad.status === 'Pending')  {
          return ad
        }
      })
      return obtainedAds
    },
    pendingEvents() {
      let pendingEvents = this.events.all.filter((event) => {
        if (!event.approved && !event.rejected) {
          return event
        }
      })
      pendingEvents.sort((a, b) => {
        a = new Date(a.dates[0].date)
        b = new Date(b.dates[0].date)
        return a<b ? -1 : a>b ? 1 : 0
      })
      return pendingEvents
    },
    ...mapState([
      'user',
      'allAds',
      'events',
      'allAttractions',
      'allRestaurants',
      'allParks',
      'selectedAttraction',
      'selectedRestaurant',
      'selectedPark'
    ])
  },
  data() {
    return {
      hideSidebar: false,
      attractionAdded: false,
      restaurantAdded: false,
      parkAdded: false,
      placeAdded: false,
      page: 'welcome',
      width: window.innerWidth,
      successMessage: '',
      errorMessage: '',
      uploadProgress: 0
    }
  },
  components: {
    attractions,
    parks,
    dining,
    // rss
  },
  mounted() {
    this.$store.dispatch('getAllAds')
  },
  methods: {
    cancelUpdate() {
      this.page = 'welcome'
      this.hideSidebar = false
      this.editing = false
    },
    uploadImage(event, type) {
      this.uploadProgress = 0
      let ref = null
      let id = null
      const extension = event.srcElement.files[0].name.split('.').pop()
      if (type === 'attraction') {
        id = '/' + type + 'sattractions/' + this.$options.filters.slug(this.selectedAttraction.name) + '.' + extension
        ref = storage.ref(id)
      }
      if (type === 'park') {
        id = '/parks/' + this.$options.filters.slug(this.selectedPark.name) + '.' + extension
        ref = storage.ref(id)
      }
      if (type === 'restaurant') {
        id = '/restaurants/' + this.$options.filters.slug(this.selectedRestaurant.name) + '-image.' + extension
        ref = storage.ref(id)
      }
      const task = ref.put(event.target.files[0])
      task.on('state_changed', (snapshot) => {
        this.uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        if ((snapshot.bytesTransferred / snapshot.totalBytes) == 1) {
          setTimeout(() => {this.$store.commit('setCurrentUploadProgress', 0)}, 1000);
          return
        }
        if ((snapshot.bytesTransferred / snapshot.totalBytes) == 0) {
          this.$store.commit('setCurrentUploadProgress', 1)
        }
      }, function(error) {
        console.log(error)
      }, () => {
        task.snapshot.ref.getDownloadURL().then((downloadURL) => {
          if (type === 'attraction') {
            let attraction = this.selectedAttraction
            attraction.imageUrl = downloadURL
            this.$store.commit('setSelectedAttraction', attraction)
          }
          if (type === 'park') {
            let park = this.selectedPark
            park.imageUrl = downloadURL
            this.$store.commit('setSelectedPark', park)
          }
          if (type === 'restaurant') {
            let restaurant = this.selectedRestaurant
            restaurant.imageUrl = downloadURL
            this.$store.commit('setSelectedRestaurant', restaurant)
          }
        })
      })
    },
    addPlace(placeType) {
      const placeTypeAdded = placeType + 'Added'
      this[placeTypeAdded] = true
      const itemName = this.selectedPlace.name
      let newUrl = this.$options.filters.slug(itemName)

      let count = 0
      const placeList = 'all' + placeType.charAt(0).toUpperCase() + placeType.slice(1) + 's'
      console.log(placeList)
      for (let place of this[placeList]) {
        if (place.url === newUrl) {
          count++
          continue
        }
        for (let i = 0; i < this[placeList].length; i++) {
          if (place.url === newUrl + "-" + i) {
            count++
            break
          }
        }
      }
      
      if (count > 0) {
        newUrl = newUrl + "-" + (Number(count) + 1)
        this.selectedPlace.name = this.selectedPlace.name + "-" + (Number(count) + 1)
      }
      this.selectedPlace.url = newUrl
      this.selectedPlace.type = placeType

      // const placeAdd = 'add' + placeType.charAt(0).toUpperCase() + placeType.slice(1)
      this.$store.dispatch('addPlace', this.selectedPlace).then(() => {
        this.$store.dispatch('getPlaces', placeType).then(() => {
          this[placeTypeAdded] = false
        })
      })

      // Clear input fields
      let inputElements = document.getElementsByClassName('addInput')
      for (let element of inputElements) {
        element.value = ''
      }

    },
    editPlace(data) {
      this.$store.dispatch('getPlaceByID', data).then(() => {
        const typeEdit = data.type + '-edit'
        this.pageNav(typeEdit)
        this.hideSidebar = true
        this.editing = true
      })
    },
    removePlace(data) {
      if(confirm("Delete place " + data.name + '?')) {
        this.$store.dispatch('removePlace', data).then(() => {
          console.log('removed place: ' + data.name)
        })
      }
    },
    updatePlace(id, place) {
      let data = {
        id: id,
        type: place.type + 's',
        doc: place
      }
      this.$store.dispatch('updateDoc', data).then(() => {
        this.$store.dispatch('getPlaces', place.type).then(() => {
          this.page = 'welcome'
          this.hideSidebar = false
          this.editing = false
        })
      })
    },
    decideAd(ad, bool) {
      if (bool) {
        ad.status = 'Active'
      } else {
        ad.status = 'Rejected'
      }
      this.$store.dispatch('updateAd', ad).then(() => {
        this.$store.dispatch('getAllAds')
      })
    },
    decideEvent(event, bool) {
      if (bool) {
        event.approved = true
      } else {
        event.rejected = true
      }
      this.$store.dispatch('updateEvent', event).then(() => {
        this.$store.dispatch('getEvents')
      })
    },
    
    pageNav(page) {
      this.page = page
      window.scrollTo(0, 0)
    },
    viewEvent(event) {
      this.$router.push({ name: 'event-details', params: {url: event.url} })
      window.scrollTo(0, 0)
    },
    async gplaces(event) {
      const google = await gmapsInit()
      let input = event.target
      const fields = ['place_id','name','address_components','formatted_phone_number','geometry','opening_hours','website','photos','business_status']
      let autocomplete = new google.maps.places.Autocomplete(input, {types:['establishment'], fields:fields})
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace()
        if (place.business_status !== 'OPERATIONAL') {
          alert('status: ' + place.business_status)
          return
        }
        if (!place.opening_hours) {
          place.opening_hours = {
            weekday_text: "unknown"
          }
        }
        // Google Photo
        // if (place.photos) {
        //   place.imageUrl = place.photos[0].getUrl({"maxWidth": 1920})
        //   if (place.photos[0].html_attributions[0]) {
        //     place.imageAttr = place.photos[0].html_attributions[0]
        //   }
        // }
        if (place.address_components && place.address_components.length) {
          let ShouldBeComponent = {
            street_number: ["street_number"],
            postal_code: ["postal_code"],
            street_address: ["street_address", "route"],
            state: [
              "administrative_area_level_1",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "administrative_area_level_4",
              "administrative_area_level_5"
            ],
            city: [
              "locality",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "sublocality_level_3",
              "sublocality_level_4"
            ],
            country: ["country"]
          }
    
          let address = {
            street_number: "",
            postal_code: "",
            street_address: "",
            state: "",
            city: "",
            country: ""
          }
          place.address_components.forEach(component => {
            for (var shouldBe in ShouldBeComponent) {
              if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                  address[shouldBe] = component.short_name
                } else {
                  address[shouldBe] = component.long_name
                }
              }
            }
          })
          
          place.displayAddress = address.street_number + " " + address.street_address + " " + address.city + ", " + address.state + " " + address.postal_code
        } else {
          place.displayAddress = 'unknown'
        }
        this.selectedPlace = {
          name: place.name,
          place_id: place.place_id,
          displayAddress: place.displayAddress,
          phone: place.formatted_phone_number,
          latlng: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
          hours: place.opening_hours.weekday_text,
          website: place.website,
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/image-placeholder.jpg?alt=media&token=43ef9ce3-833c-47ed-9911-cae82229176a",
          imageAttr: "placeholder"
        }
        for (let key of Object.keys(this.selectedPlace)) {
          if (this.selectedPlace[key] === undefined || this.selectedPlace[key] === null) {
            this.selectedPlace[key] = ''
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
